import styled from 'styled-components';
import { unitizedPx } from '@badi/badi-components';

export const Root = styled.div`
  min-width: ${unitizedPx(31)};
`;
